module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABT0lEQVRYR+2XK0sFURSFv5VMBm2CwWQzCVoM+gcMisEgaFF8BX+B+g8uCBp9REGLVlERk1hsNjUYDYJ5ybnMlbkP7gwzHC7InDhn770+1j7M2Uf0eKnH+rQB2F4FFoHpSHB3wL2kvVD/D8B2H/AIjEcS7lR2IA1wAGwBgfAZuI4EMgGsAyNALQ3wCowCO5JqkcTrZW0vA8fATxrAieiMpOBC1GW7rlcBVA5UDlQOVA5UDqQd+Ab6gXlJlzFvIttDwGfrZfQATAEnklYiA5wBS8BT2oHwIWyE9QacRoLYBgaT2mtNM6HtBeA8knBr2SNJG52G0jFgEhjOCbKbxO3njH8HPiTdNJ2BnMltYY3JBig0SZV+F/x/ANvh39DtrXDbGGa7tPFF0len/cwWpEboosck5F1Jmi0KMAdclFEHDiVtFgIoKZyZntmCzAolA34B3ALUnTQayuYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left/diannao0.png
// module id = al5J
// module chunks = 3